import React, { FC, useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { TabNavigation } from 'common/components';
import { ERoute } from 'common/const';
import { RequestListTab, SupplyListTab, SupplyListTabForUser } from 'entities/Request/components';
import { ERequestListPageTab } from 'entities/Request/Request.enum';
import { getRequestListPageTabs } from 'entities/Request/Request.helper';
import { EUserRole } from 'entities/User/User.enum';

export const RequestListPage: FC = () => {
  const { role, tab1: tab, tab2 } = useParams();

  const asUser = role === EUserRole.User;
  const asSellerManager = role === EUserRole.SellerManager;
  const header = useMemo(
    () => (
      <>
        <div className="text-body color-dark-grey mb-6">{asSellerManager ? 'Заказы на поставку' : 'Заказы на закупку'}</div>

        <TabNavigation items={getRequestListPageTabs(role)} />
      </>
    ),
    [role],
  );

  const renderContent = () => {
    switch (true) {
      case tab === ERequestListPageTab.Supplies && asUser: {
        return <SupplyListTabForUser header={header} />;
      }
      case tab === ERequestListPageTab.Supplies: {
        return <SupplyListTab header={header} role={role} />;
      }
      default: {
        return <RequestListTab header={header} role={role} tab={tab2} />;
      }
    }
  };

  if (!role) {
    return <Navigate to={ERoute.Profile} replace />;
  }

  if (!tab) {
    return <Navigate to={`${ERoute.RequestList}/${role}/${ERequestListPageTab.Requests}`} replace />;
  }

  return <div className="redesign request-list">{renderContent()}</div>;
};
